import React, { useState, Dispatch, CSSProperties, useRef } from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import {
  Box,
  Button,
  ButtonGroup,
  CircularProgress,
  FormControl,
  Grid,
  Radio,
  Select,
  Slider,
  TextField,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { StateAction } from "./state/actions/actions";
import { StateInterface } from "./state/reducer/store";
import languages from "../assets/freeLanguages";
import SendIcon from "@material-ui/icons/Send";
import sanitizeHtml from "sanitize-html";
import axios from "axios";
import Alert from "@material-ui/lab/Alert";
import AudioPlayerComponent from "./AudioPlayer";
import GetAppIcon from "@material-ui/icons/GetApp";
import firebase from "../assets/firebase";
import { useEffect } from "react";
import StarsIcon from '@material-ui/icons/Stars';
import { premiumVoice, premiumVoices } from "../assets/premiumVoices";
import { ContentState, EditorState } from "draft-js";
import { theme } from "../assets/theme";
import { tesseractLanguages } from "../assets/tesseractLanguages";
import PublishIcon from '@material-ui/icons/Publish';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      color: "white",
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
      textAlign: "center",
      fontSize: 26,
    },
    center: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
    },
    selected: {
      "&&": {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.background.paper
      }
    }
  })
);

const Generator = () => {
  const textToTranslate = useSelector((state: StateInterface) =>
    state.textEditorState.getCurrentContent().getPlainText()
  );
  const loadingAudiobook = useSelector(
    (state: StateInterface) => state.loadingAudiobook
  );
  const loadAudiobookError = useSelector(
    (state: StateInterface) => state.loadAudiobookError
  );
  const User = useSelector(
    (state: StateInterface) => state.user
  );

  const config = useSelector(
    (state: StateInterface) => state.config
  );

  const dispatch: Dispatch<StateAction> = useDispatch();
  const [source, setSource] = useState("");
  const [selectedVoice, setSelectedVoice] = useState<string | premiumVoice>("en");
  const apiErrorMessage = useSelector((state: StateInterface) => state.apiErrorMessage)
  const apiMessage = useSelector((state: StateInterface) => state.apiMessage)
  const isFileConverting = useSelector((state: StateInterface) => state.isFileConverting)
  const audioEncoding = useSelector((state: StateInterface) => state.audioEncoding)
  const [showWaveNetVoices, setShowWaveNetVoices] = useState(false);
  const file = useSelector((state: StateInterface) => state.pdfFile)
  const showImageLanguageOptions = useSelector((state: StateInterface) => state.showImageLanguageOptions)
  const [pitch, setPitch] = useState(0)
  const [speakingRate, setSpeakingRate] = useState(1)
  const mustBeLoggedInError = useSelector((state: StateInterface) => state.mustBeLoggedInError)
  const classes = useStyles();
  const inputFileRef = useRef(null);
  const centerStyle: CSSProperties = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  };

  const getTextFromFile = async (file: File, lang?: string) => {
    if (!file) {
      console.log("PDF File does not exist");
      return;
    }
    const formData = new FormData();

    formData.append("file", file);
    if (lang && tesseractLanguages.find(lan => lan.id === lang)) {

    }
    try {
      dispatch({
        type: "SET_IS_FILE_CONVERTING",
        payload: true
      });
      const res = await axios.post(config.getTextFromFileUrl, formData);
      const { text } = res.data;
      dispatch({
        type: "SET_TEXT_EDITOR_STATE",
        payload: EditorState.createWithContent(
          ContentState.createFromText(text)
        ),
      });
      dispatch({
        type: "SET_IS_FILE_CONVERTING",
        payload: false
      });
      dispatch({
        type: "SHOW_IMAGE_LANGUAGE_OPTIONS",
        payload: false
      });
    } catch (e) {
      console.log(e);

      dispatch({
        type: "SHOW_IMAGE_LANGUAGE_OPTIONS",
        payload: false
      });
      //DISPATCH PDF ERROR MESSAGE
      dispatch({
        type: "SET_IS_FILE_CONVERTING",
        payload: false
      });
      dispatch({
        type: 'SET_API_ERROR_MESSAGE',
        payload: e?.response?.data === "File type is not supported." ? config.textByLanguage["fileTypeNotSupported"] : "There was a server error. Please try again later."
      })
      setTimeout(() => {
        dispatch({
          type: 'SET_API_ERROR_MESSAGE',
          payload: ''
        })
      }, 7000);
    }
  };


  function chunkSubstr(str: string, size: number) {
    const numChunks = Math.ceil(str.length / size);
    const chunks = new Array(numChunks);

    for (let i = 0, o = 0; i < numChunks; ++i, o += size) {
      chunks[i] = str.substr(o, size);
    }

    return chunks;
  }

  useEffect(() => {
    if (!User) return;
    const doc = firebase.firestore().collection('users').doc(User.uid);
    const unsubscribe = doc.onSnapshot((snap) => {
      const snapShot = snap.data()
      dispatch({ type: "SET_USER", payload: { ...User, ...snapShot } })
    })
    return () => {
      unsubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [User?.uid])


  const handleCreateFreeAudioClick = async () => {
    // if (!User) {
    //   dispatch({ type: 'SET__USER_MUST_BE_LOGGED_IN_ERROR', payload: true })
    //   setTimeout(() => {
    //     dispatch({ type: 'SET__USER_MUST_BE_LOGGED_IN_ERROR', payload: false })
    //   }, 5000);
    //   return
    // }

    try {
      dispatch({ type: "START_CREATING_AUDIOBOOK" });
      const cleanText = sanitizeHtml(textToTranslate, {
        allowedTags: [],
        allowedAttributes: {},
      });
      if (cleanText.length > 10000) {
        let output: any = [];
        const brokenUpText = chunkSubstr(cleanText, 10000);
        for (let i = 0; i < brokenUpText!.length; i++) {
          const temp = await axios.post(config.audioConvertUrl, {
            text: brokenUpText[i],
            selectedVoice: selectedVoice ? selectedVoice : "en",
          });
          output.push(
            temp.data.reduce(
              (accum: string, curr: { base64: string }) => accum + curr.base64,
              ""
            )
          );
        }

        setSource(
          `data:audio/mp3;base64,${output.reduce(
            (accum: string, curr: { base64: string }) => accum + curr,
            ""
          )}`
        );
        dispatch({ type: "FINISHED_CREATING_AUDIOBOOK" });
      } else {
        const res = await axios.post(
          config.audioConvertUrl,
          {
            text: cleanText,
            selectedVoice: selectedVoice ? selectedVoice : "en",
          }
        );
        setSource(
          `data:audio/mp3;base64,${res.data.reduce(
            (accum: string, curr: { base64: string }) => accum + curr.base64,
            ""
          )}`
        );
        dispatch({ type: "FINISHED_CREATING_AUDIOBOOK" });
      }
    } catch (e) {
      dispatch({
        type: 'SET_API_ERROR_MESSAGE',
        payload: e?.response?.data || "There was a server error. Please try again later."
      })
      setTimeout(() => {
        dispatch({
          type: 'SET_API_ERROR_MESSAGE',
          payload: ''
        })
      }, 7000);
      //   dispatch({ type: "SET_LOAD_AUDIOBOOK_ERROR" });
      dispatch({ type: "FINISHED_CREATING_AUDIOBOOK" });

    }
  };

  const handlePremiumAudioCreation = async () => {
    if (!User) {
      dispatch({ type: 'SET__USER_MUST_BE_LOGGED_IN_ERROR', payload: true })
      setTimeout(() => {
        dispatch({ type: 'SET__USER_MUST_BE_LOGGED_IN_ERROR', payload: false })
      }, 5000);
      return
    }

    try {
      dispatch({ type: "START_CREATING_AUDIOBOOK" });
      const cleanText = sanitizeHtml(textToTranslate, {
        allowedTags: [],
        allowedAttributes: {},
      });
      const token = await firebase.auth().currentUser?.getIdToken()
      const uid = firebase.auth().currentUser?.uid

      const res = await axios.post(
        config.getPremiumVoiceUrl,
        {
          text: cleanText,
          name: typeof selectedVoice !== 'string' ? selectedVoice.name : "en-US-Wavenet-H",
          uid: uid,
          audioEncoding: audioEncoding,
          speakingRate: speakingRate,
          pitch: pitch
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );
      if (cleanText.length >= config.maxPremiumCharacters) {
        dispatch({
          type: 'SET_API_MESSAGE',
          payload: `Your job id = ${res.data} A confirmation email has been emailed to you.`
        })
        setTimeout(() => {
          dispatch({
            type: 'SET_API_MESSAGE',
            payload: ''
          })
        }, 15000);
      } else {
        setSource(
          `data:audio/${audioEncoding === 'MP3' ? 'mp3' : 'wav'};base64,${res.data}`
        );
      }
      dispatch({ type: "FINISHED_CREATING_AUDIOBOOK" });
    } catch (e) {
      console.log(e)
      dispatch({
        type: 'SET_API_ERROR_MESSAGE',
        payload: e?.response?.data || "There was a server error. Please try again later."
      })
      setTimeout(() => {
        dispatch({
          type: 'SET_API_ERROR_MESSAGE',
          payload: ''
        })
      }, 7000);
      dispatch({ type: "FINISHED_CREATING_AUDIOBOOK" });

    }


  }

  const isCreateAudioButtonDisabled = () => {
    const premiumVoiceQuota = User?.premiumVoiceQuota
    if (premiumVoiceQuota && showWaveNetVoices) {
      return textToTranslate.length > premiumVoiceQuota
    }
    return textToTranslate.length > config.maxFreeCharacters
  }
  return (
    <div
      className={classes.root}
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: 'column',
        alignItems: 'center',
        color: 'black',
        marginTop: '5rem'
      }}

    >
      {apiErrorMessage &&
        <Alert variant="filled" severity="error" style={{ margin: '24px 0', width: '100%', fontSize: 16, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {apiErrorMessage}
        </Alert>}
      {apiMessage &&
        <Alert variant="filled" severity="success" style={{ margin: '24px 0', width: '100%', fontSize: 16, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {apiMessage}
        </Alert>}
      <AppBar position="static" color="default" style={{ maxWidth: 1200 }}>
        <Toolbar
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 24,
          }}
        >
          <Grid container>
            <Grid item xs={12}>

              {mustBeLoggedInError &&
                <Alert
                  variant="filled"
                  severity="warning"
                  style={{ marginTop: 32, fontSize: 18, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                  {config.textByLanguage.pleaseSignIn}
                </Alert>}
            </Grid>
            <Grid item xs={12} md={4} style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
              {!showImageLanguageOptions && <Typography variant="h6">
                1. {config.textByLanguage["generator.step1"]}
              </Typography>}
              {showImageLanguageOptions && <Typography variant="h6" style={{ textAlign: 'center' }}>
                {config.textByLanguage.whatIsTheLanguageInTheText}?
              </Typography>}
              {!showImageLanguageOptions && <>
                <Button
                  style={{ padding: "0 76px", height: 56, margin: '8px 0' }}
                  onClick={(e) => (inputFileRef as any).current.click()}
                  variant="contained"
                  color="primary"
                >
                  <input
                    type="file"
                    style={{ display: "none" }}
                    ref={inputFileRef}
                    onChange={(e) => {
                      dispatch({
                        type: "SET_FILE",
                        payload: (e.target.files && e.target.files[0]) || null,
                      });
                      if (e.target.files && e.target.files[0] && e.target.files[0].type.includes('image')) {
                        dispatch({
                          type: 'SHOW_IMAGE_LANGUAGE_OPTIONS',
                          payload: true
                        })
                        dispatch({
                          type: 'SET_FILE',
                          payload: e.target.files[0]
                        })

                      } else if (e.target.files && e.target.files[0]) {
                        getTextFromFile(e.target.files[0])
                      }

                    }


                    }
                    accept="application/pdf, image/png, image/jpeg, image/jpg, image/bmp, image/pbm, application/msword, text/plain, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  />
                  <PublishIcon
                    style={{ fontSize: 32, color: theme.palette.common.white, marginRight: 16 }}
                  />
                  {config.textByLanguage["generator.upload"]}
                </Button>

                <Typography variant="body1">
                  {config.textByLanguage["generator.step1.supportedFileExtensions"]}
                  .pdf
                  .png
                  .jpeg
                  .jpg
                  .csv
                  .xls
                  .xlsx
                  .bmp
                  .pbm
                  .dot
                  .docx
                  .txt
                </Typography>
              </>}

              {showImageLanguageOptions &&
                <>

                  <FormControl variant="outlined">
                    <Select
                      native
                      onChange={(event: any) => {
                        if (file) {
                          getTextFromFile(file, event.target.value)
                        } else {
                          console.log('FILE IS EMPTY')
                        }
                      }}
                    >
                      <option aria-label="None" value="" />
                      {tesseractLanguages.map((lang) => <option value={lang.id} key={lang.id}>{lang.name}</option>)}
                    </Select>
                  </FormControl>
                </>}

            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              style={{ ...centerStyle, margin: "24px 0" }}
            >
              <Typography variant="h6">2. {config.textByLanguage["generator.step2"]}</Typography>
              <Box style={{ display: 'flex', justifyContent: 'space-evenly', width: 300, marginBottom: 8 }}>

                <ButtonGroup color="primary" aria-label="outlined primary button group">
                  <Button disableElevation variant="contained" size='large' color={showWaveNetVoices ? 'default' : 'primary'} onClick={() => setShowWaveNetVoices(false)} style={{ opacity: showWaveNetVoices ? '0.5' : undefined }}>{config.textByLanguage["generator.step2.basic"]}</Button>
                  <Button disableElevation variant="contained" size='large' color={showWaveNetVoices ? 'primary' : 'default'} onClick={() => setShowWaveNetVoices(true)} style={{ opacity: !showWaveNetVoices ? '0.5' : undefined }}>
                    {config.textByLanguage["generator.step2.neuralVoice"]} < StarsIcon style={{ marginLeft: 8 }} />
                  </Button>
                </ButtonGroup>
              </Box>

              {showWaveNetVoices &&
                <Autocomplete
                  id={`${selectedVoice} 1`}
                  options={premiumVoices.sort((a, b) => {
                    if (a.language[0] < b.language[0]) {
                      return -1;
                    } else if (a.language[0] > b.language[0]) {
                      return 1;
                    } else return 0
                  })}
                  onChange={(e, val) => {
                    setSelectedVoice(val || 'en')
                  }}

                  getOptionLabel={(option) => `${option.language} - ${option.humanName}`}
                  style={{ width: 300 }}
                  defaultValue={premiumVoices[53]}
                  getOptionSelected={(option, value) => option.name === value.name}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                  )}
                  renderOption={(option => {
                    return <div style={{ display: 'flex', alignItems: 'center' }}>{`${option.language} - ${option.humanName}`} {option.name.includes("Wavenet") && < StarsIcon style={{ marginLeft: 8 }} />} </div>;
                  })}
                />}
              {!showWaveNetVoices &&
                <Autocomplete
                  id={`${selectedVoice} 2`}
                  onChange={(e, val) => setSelectedVoice(val?.key || "en")}
                  options={languages}
                  getOptionLabel={(option) => option.title}
                  style={{ width: 300 }}
                  clearOnEscape
                  defaultValue={{ title: "English (US)", key: "en" }}
                  getOptionSelected={(option, value) => option.key === value.key}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                  )}
                />}

              {showWaveNetVoices && <Box >
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                  <Radio
                    checked={audioEncoding === 'MP3'}
                    onChange={() => dispatch({
                      type: 'SET_AUDIO_ENCODING',
                      payload: 'MP3'
                    })}
                    value="MP3"
                    name="radio-button-mp3"
                    inputProps={{ 'aria-label': 'A' }}
                  />
                  <Typography variant="body2">
                    <b>{config.textByLanguage["mp3.title"]}</b> {config.textByLanguage["mp3.description"]}
                  </Typography>
                </Box>

                <Box style={{ display: 'flex', alignItems: 'center' }}>
                  <Radio
                    checked={audioEncoding === 'LINEAR16'}
                    onChange={() => dispatch({
                      type: 'SET_AUDIO_ENCODING',
                      payload: 'LINEAR16'
                    })}
                    value="a"
                    name="radio-button-linear16"
                    inputProps={{ 'aria-label': 'A' }}
                  />
                  <Typography variant="body2">
                    <b>{config.textByLanguage["wav.title"]}</b> {config.textByLanguage["wav.description"]}
                  </Typography>
                </Box>
              </Box>}

              {showWaveNetVoices && <Box style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <Typography id="discrete-slider" gutterBottom style={{ margin: '8px 0 40px 0' }}>
                  <b>{config.textByLanguage["generator.step2.speakingRate"]}</b>
                </Typography>
                <Slider
                  valueLabelDisplay="on"
                  defaultValue={1}
                  // getAriaValueText={valuetext}
                  aria-labelledby="discrete-slider"
                  step={.01}
                  min={.25}
                  max={4}
                  onChange={(_, val) => {
                    if (typeof val !== 'number') {
                      setSpeakingRate(val[0])
                    } else {
                      setSpeakingRate(val)
                    }
                  }}
                />
                <Typography id="discrete-slider" gutterBottom style={{ margin: '8px 0 40px 0' }}>
                  <b>{config.textByLanguage["generator.step2.pitch"]}</b>
                </Typography>
                <Slider
                  valueLabelDisplay="on"
                  defaultValue={0}
                  // getAriaValueText={valuetext}
                  aria-labelledby="discrete-slider"
                  step={.01}
                  min={-20}
                  max={20}
                  onChange={(_, val) => {
                    if (typeof val !== 'number') {
                      setPitch(val[0])
                    } else {
                      setPitch(val)
                    }
                  }}
                />


              </Box>}


            </Grid>
            <Grid item xs={12} md={4} style={centerStyle}>
              <Typography variant="h6">3. {config.textByLanguage["generator.step3"]}</Typography>
              <Button
                variant="contained"
                color="primary"
                style={{ padding: "0 24px", height: 56 }}
                disabled={
                  isCreateAudioButtonDisabled() || loadingAudiobook || isFileConverting
                }
                onClick={() => showWaveNetVoices ? handlePremiumAudioCreation() : handleCreateFreeAudioClick()}
              >
                {config.textByLanguage["generator.step3.createAudioButton"]}
                {loadingAudiobook && (
                  <CircularProgress style={{ marginLeft: 16 }} />
                )}
                {!loadingAudiobook && <SendIcon style={{ marginLeft: 16 }} />}
              </Button>
            </Grid>

            <Grid item xs={12}>
              {source && (
                <>
                  <Box style={{ margin: "24px 0" }}>
                    <AudioPlayerComponent src={source} autoPlay />
                  </Box>

                  <Grid item xs={12} style={centerStyle}>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{
                        padding: "6px 32px 10px 32px",
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <a
                        href={source}
                        download="audiobook"
                        style={{ color: "white", textDecoration: "none" }}
                      >
                        Download Audio
                        <GetAppIcon
                          style={{ position: "relative", top: 7, left: 10 }}
                        />
                      </a>
                    </Button>
                  </Grid>
                </>
              )}
            </Grid>

            <Grid item xs={12}>
              {isCreateAudioButtonDisabled() && (
                <Alert
                  variant="filled"
                  severity="warning"
                  style={{ marginTop: 32, fontSize: 18, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                >
                  {showWaveNetVoices ? config.textByLanguage.maxCharacterPremiumErrorMessage : config.textByLanguage.maxCharacterFreeErrorMessage}
                </Alert>
              )}

            </Grid>




            <Grid item xs={12}>
              {loadAudiobookError && (
                <Alert
                  variant="filled"
                  severity="warning"
                  style={{ marginTop: 32 }}
                >
                  {config.textByLanguage.serverError}
                </Alert>
              )}
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </div >
  );
};

export default Generator;
